import { useEffect, useState } from "react";

import { isWindowInIframe } from "@/v2/utils/isInIframe";

export const useInIframe = () => {
  const [isInIframe, setIsInIframe] = useState(false);

  useEffect(() => {
    setIsInIframe(isWindowInIframe());
  }, []);

  return isInIframe;
};
